export default __webpack_public_path__ + "static/media/logo01-1.47ee3fe6.png";